export const GET_INFO = 'GET_INFO';
export const POST_PLAYERS = 'POST_PLAYERS';
export const SET_STATUS_INFO = 'SET_STATUS_INFO';
export const FILTER_RANDOM ='FILTER_RANDOM';
export const FILTER_LUCKY_RANDOM ='FILTER_LUCKY_RANDOM';
export const FILTER_COMUNAL_RANDOM ='FILTER_COMUNAL_RANDOM';

